/**
 * The board row's amber "what's missing" cluster — one small icon per gap
 * (same icons as the editor tabs they point to), each with a tooltip
 * naming the gap, its consequence, and where to fix it. Renders nothing
 * when the container is fully set up: configured rows stay calm.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { AtSign, Layers, MessageSquareText, RadioTower, Rows3, Unlink } from 'lucide-react';

import { Tooltip } from '@/components/ui';

import type { SetupHint, SetupHintKey } from '../../../utils/setup-hints';

const ICONS: Record<SetupHintKey, FC<{ className?: string }>> = {
  groups: Layers,
  slots: Rows3,
  slotNoGroup: Unlink,
  gateways: RadioTower,
  texts: MessageSquareText,
  senders: AtSign,
};

export const SetupHintIcons: FC<{ hints: SetupHint[] }> = ({ hints }) => {
  if (hints.length === 0) return null;
  return (
    <span className="flex items-center gap-1" aria-label="Incomplete setup">
      {hints.map((hint) => {
        const Icon = ICONS[hint.key];
        return (
          <Tooltip key={hint.key} content={hint.label}>
            <span className="rounded bg-amber-500/15 p-0.5 text-amber-600 dark:text-amber-400">
              <Icon className="h-3 w-3" />
            </span>
          </Tooltip>
        );
      })}
    </span>
  );
};
